import { useTranslation } from 'react-i18next';
import { PageHeader } from 'ui/shared/pageHeader';
import { HelpVideo } from '../helpVideo/HelpVideo';
import { videos } from './helpVideos';

require('./HelpPage.css');

export const HelpPage = () => {
    const { t } = useTranslation();

    return (
        <div id="help-area">
            <PageHeader
                title={ t('HELP.TITLE') }
            />
            <div id="page-content">
                <div id="help-page" className="page">
                    <a
                        id="download-user-guide"
                        className="ui primary red button"
                        href="https://www.store.madelevator.com/files/support/mosaicone-user-guide.pdf"
                        target="_blank"
                        rel="noreferrer"
                    >
                        { t('HELP.DOWNLOAD_USER_GUIDE') }
                    </a>
                    { videos.map(v =>
                        <HelpVideo
                            key={ v.url }
                            title={ v.title }
                            description={ v.description }
                            url={ v.url }
                        />
                    ) }
                </div>
            </div>
        </div>
    );
};
